'use strict';exports.__esModule = true;var capitaliseString = function capitaliseString(string) {return string.substr(0, 1).toUpperCase() + string.substr(1);};

var underscoreNotationToCamelCase = function underscoreNotationToCamelCase() {var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var array = string.split('_');
  var capitalisedArray = array.map(function (item, idx) {return idx !== 0 ? capitaliseString(item) : item;});
  return capitalisedArray.join('');
};exports.default =

underscoreNotationToCamelCase;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/underscoreNotationToCamelCase.js
// module id = 1299
// module chunks = 0